import { Container } from 'inversify';
import { ConfigOptionsService } from 'src/core/services/config-options.service';
import AuditService from 'src/app/general/audit/audit.service';
import CacheStoreService from 'src/app/general/cache/cache-store.service';

export function setup(container: Container) {
	container.bind(ConfigOptionsService).toSelf();
	container.bind(AuditService).toSelf();
	container.bind(CacheStoreService).toSelf();
}



// WEBPACK FOOTER //
// ./src/app/general/general.config.ts